import { render, staticRenderFns } from "./newFollowUp.vue?vue&type=template&id=f1739c54&scoped=true"
import script from "./newFollowUp.vue?vue&type=script&lang=js"
export * from "./newFollowUp.vue?vue&type=script&lang=js"
import style0 from "./newFollowUp.vue?vue&type=style&index=0&id=f1739c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1739c54",
  null
  
)

export default component.exports